export default __webpack_public_path__ + "static/media/discover.ac25719e.svg";